<div class="auth-wrapper" *ngIf="loading">
  <p>Logging you in via CIAM...</p>
  <mat-progress-spinner mode="indeterminate" diameter="48"></mat-progress-spinner>
</div>
<div class="auth-wrapper" *ngIf="!loading && !error">
  <p>Login successful. Redirecting...</p>
</div>
<div class="auth-wrapper error" *ngIf="!loading && error">
  <h3>CIAM Login Error</h3>
  <p>{{error}}</p>
  <button mat-button color="primary" (click)="ciamService.redirectToCiamLogin()">Retry Login</button>
</div>